import { render, staticRenderFns } from "./RepositoryManager.vue?vue&type=template&id=3c93bec1"
import script from "./RepositoryManager.vue?vue&type=script&lang=js"
export * from "./RepositoryManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports